const NodeStyle = {
    width: 100, // 5 grid cells (assuming 20px grid)
    height: 60, // 3 grid cells (assuming 20px grid)
    shape: 'rectangle',
    opacity: 1,
    backgroundColor: '#ffcc00',
    borderColor: '#000',
    borderWidth: 1,
};

const EdgeStyle = {
    thickness: 2,
    backgroundColor: '#555',
    shape: 'solid',
};

export { NodeStyle, EdgeStyle };
